import { render, staticRenderFns } from "./HelpCenterList.vue?vue&type=template&id=87a6a72c&"
import script from "./HelpCenterList.vue?vue&type=script&lang=js&"
export * from "./HelpCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports